/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicoModelDto } from '../../models/medico-model-dto';

export interface MedicosControllerObtenerMedicos$Params {
}

export function medicosControllerObtenerMedicos(http: HttpClient, rootUrl: string, params?: MedicosControllerObtenerMedicos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MedicoModelDto>>> {
  const rb = new RequestBuilder(rootUrl, medicosControllerObtenerMedicos.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MedicoModelDto>>;
    })
  );
}

medicosControllerObtenerMedicos.PATH = '/api/medicos/obtener-medicos';
